<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>订单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse>
          <el-row class="search-row">
            <el-col :span="4" class="display-row">
              <div class="query-title">待办员工:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.workerName" size="small"
                          @keyup.enter.native="handleSearchList()">
                </el-input>
              </div>
            </el-col>
            <el-col :span="4" class="display-row">
              <div class="query-title">客户名称:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.customerName" size="small"
                          @keyup.enter.native="handleSearchList()">
                </el-input>
              </div>
            </el-col>
            <el-col :span="4" class="display-row">
              <div class="query-title">业务单号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.number" size="small"
                          @keyup.enter.native="handleSearchList()">
                </el-input>
              </div>
            </el-col>
            <el-col :span="4" class="display-row">
              <div class="query-title">车间状态:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.transacState" placeholder="请选择" size="small" clearable>
                  <el-option key="0" value="0" label="未完成"></el-option>
                  <el-option key="1" value="1" label="已完成"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="4" :offset="2" class="display-row">
              <el-button class="search-btn lx-mb5 btn-gray" @click="handleQueryInfoClear">重置</el-button>
              <el-button class="search-btn lx-mb5 btn-blue" @click="handleSearchList" >搜索</el-button>
              <el-button class="search-btn lx-mb5 btn-blue" @click=" ModifyPageVisible = true">新增</el-button>
            </el-col>
          </el-row>
        </el-collapse>
      </div>

      <div
          slot="table"
          class="full-height display-col"
      >
        <el-table
            :data="transactList"
            border
            style="width: 100%"
            height="550"
            v-loading="isLoading"
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
        >
          <el-table-column
              type="index"
              label="序号"
              align="center"
              width="40"
          ></el-table-column>

          <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
              width="100">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>

          <el-table-column
              prop="workerName"
              label="待办员工"
              align="center"
          >
            <template slot-scope="scope">
              {{typeof  scope.row.workerName== "undefined" ||  scope.row.workerName== null ||  scope.row.workerName.trim()== ""?scope.row.workerUserName:scope.row.workerName}}
            </template>
          </el-table-column>

          <el-table-column
              prop="customerName"
              label="客户名称"
              align="center"
          >
            <template slot-scope="scope">
              {{typeof scope.row.customerName== "undefined" || scope.row.customerName== null || scope.row.customerName.trim()== ""?scope.row.customerUserName:scope.row.customerName}}
            </template>
          </el-table-column>

          <el-table-column
              prop="number"
              label="业务单号"
              align="center"
              min-width="100"
          />

          <el-table-column
              prop="typeName"
              label="待办类型"
              align="center"
              min-width="100"
          />
          <el-table-column
              prop="remark"
              label="待办说明"
              align="center"
              min-width="100"
          />
          <el-table-column
              prop="workshopState"
              label="车间状态"
              align="center"
              min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.workshopState == 0" style="color: #F56C6C">未完成</span>
              <span v-else style="color: #67C23A">已完成</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="officeState"
              label="办公室状态"
              align="center"
              min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.officeState == 0"> <el-button type="primary" size="mini" @click="handleUpdate(scope.row,'1')">完成</el-button></span>
              <span v-else style="color: #67C23A">已完成</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="entryState"
              label="条目状态"
              align="center"
              min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.entryState == 0"> <el-button type="primary" size="mini" @click="handleUpdate(scope.row,'2')">完成</el-button></span>
              <span v-else style="color: #67C23A">已完成</span>
            </template>
          </el-table-column>

          <el-table-column
              label="操作"
              align="center"
              min-width="100"
          >
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>

<!--新增弹窗-->
    <el-dialog
        :visible.sync="ModifyPageVisible"
        title="新增待办"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
    >
      <el-form
          :model="transactInfo"
          ref="transactInfo"
          class="demo-userInfo"
          :rules="rules"
      >
        <el-row class="search-row">
          <el-col>
            <el-form-item label="待办员工：" prop="workerName" label-width="120px">
              <el-input v-model="transactInfo.workerName" size="small" disabled style="width: 75%"></el-input>
              <el-button type="primary" size="small" style="margin-left: 10px" @click="handleOpenUserList">选择员工</el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="search-row">
          <el-col>
            <el-form-item label="关联客户：" prop="customerName" label-width="120px">
              <el-input v-model="transactInfo.customerName" style="width: 75%" size="small" disabled></el-input>
              <el-button type="primary" size="small" style="margin-left: 10px" @click="handleOpenCustomerList">选择客户</el-button>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row class="search-row">
          <el-col>
            <el-form-item label="业务单号：" prop="number" label-width="120px">
              <el-input v-model="transactInfo.number" style="width: 75%" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="待办类型:" label-width="120px" prop="typeName">
          <el-input v-model="transactInfo.typeName" style="width: 75%" size="small"></el-input>
        </el-form-item>

        <el-form-item label="待办说明:" label-width="120px" prop="remark">
          <el-input v-model="transactInfo.remark" style="width: 75%" size="small"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="ModifyPageVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue"  type="primary" @click="submitArrivalRemind">提 交</el-button>
      </span>
    </el-dialog>


<!--选择员工弹窗-->
    <el-dialog
        :visible.sync="userDialog"
        width="71%"
        title="选择员工"
    >
      <el-row class="search-row">
        <el-col :span="5" class="display-row">
          <div class="query-title" style="float: right">所属角色:</div>
          <div class="flex1" style="float: right">
            <el-select
                v-model="userQueryInfo.roleId"
                placeholder="请选择"
                size="small"
                clearable>
              <el-option
                  v-for="item in roleList"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5" class="display-row">
          <div class="query-title">员工ID:</div>
          <div class="flex1">
            <el-input
                placeholder="请输入内容"
                clearable
                v-model="userQueryInfo.userName"
                size="small"
                @keyup.enter.native="handleSearchUserList">
            </el-input>
          </div>
        </el-col>
        <el-col :span="14" class="display-row">
          <div
              style="
                text-align: right;
                width: 100%;
                padding-right: 10px;
                float: right;">
            <el-button class="search-btn btn-gray" @click="handleQueryInfoUserClear">重置</el-button>
            <el-button class="search-btn btn-blue" @click="handleSearchUserList()">搜索</el-button>
          </div>
        </el-col>
      </el-row>

      <el-row class="search-row">
        <div>
          <el-table
              :data="workerList"
              border
              style="width: 100%"
              height="400"
              v-loading="isLoading"
              :header-cell-style="tableStyle.headerStyle"
              :cell-style="tableStyle.cellStyle"
          >
            <el-table-column type="index" align="center" label="序号" width="40">
            </el-table-column>
            <el-table-column prop="userName" label="员工ID">
            </el-table-column>
            <el-table-column prop="realName" label="员工姓名">
            </el-table-column>
            <el-table-column prop="roleName" align="center" label="所属角色">
            </el-table-column>
            <el-table-column prop="userStatus" align="center" label="员工状态">
            </el-table-column>
            <el-table-column prop="mobileNumber" align="center" label="手机号码" >
            </el-table-column>
            <el-table-column prop="createDate" align="center" sortable label="创建时间" >
              <template v-slot="scope">
                {{ scope.row.createDate | dateFormatToSecond }}
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                min-width="100"
            >
              <template slot-scope="scope">
                <el-button  type="primary" plain @click="userChoose(scope.row)">选中</el-button>
              </template>
            </el-table-column>

          </el-table>
          <el-pagination
              @size-change="handleSizeChangeUser"
              @current-change="handleCurrentChangeUser"
              :current-page="userQueryInfo.pageNum"
              :page-sizes="[10, 20, 50, 100, 200]"
              :page-size="userQueryInfo.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="userTotal"
          ></el-pagination>
        </div>
      </el-row>
    </el-dialog>


    <!--选择客户弹窗-->
    <el-dialog
        :visible.sync="customerDialog"
        width="71%"
        title="选择客户"
    >
      <el-row class="search-row">
        <el-col :span="5" class="display-row">
          <div class="query-title">客户ID:</div>
          <div class="flex1">
            <el-input
                placeholder="请输入内容"
                clearable
                v-model="customerQueryInfo.userName"
                size="small"
                @keyup.enter.native="handleSearchUserList">
            </el-input>
          </div>
        </el-col>
        <el-col :span="14" class="display-row">
          <div
              style="
                text-align: right;
                width: 100%;
                padding-right: 10px;
                float: right;">
            <el-button class="search-btn btn-gray" @click="handleQueryInfoCustomerClear">重置</el-button>
            <el-button class="search-btn btn-blue" @click="handleSearchCustomerList()">搜索</el-button>
          </div>
        </el-col>
      </el-row>

      <el-row class="search-row">
        <div>
          <el-table
              :data="customerList"
              border
              style="width: 100%"
              height="400"
              v-loading="isLoading"
              :header-cell-style="tableStyle.headerStyle"
              :cell-style="tableStyle.cellStyle"
          >
            <el-table-column type="index" align="center" label="序号" width="40">
            </el-table-column>
            <el-table-column prop="userName" label="客户ID">
            </el-table-column>
            <el-table-column prop="realName" label="客户姓名">
            </el-table-column>
            <el-table-column prop="userFlag" align="center" label="客户状态">
              <template v-slot="scope">
                {{ scope.row.userFlag == 0 ? '启用': '禁用' }}
              </template>
            </el-table-column>
            <el-table-column prop="latestSigninTime" align="center" label="最近登录时间" >
              <template v-slot="scope">
                {{ scope.row.latestSigninTime | dateFormatToSecond }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" align="center" sortable label="创建时间" >
              <template v-slot="scope">
                {{ scope.row.createTime | dateFormatToSecond }}
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                min-width="100"
            >
              <template slot-scope="scope">
                <el-button  type="primary" plain @click="customerChoose(scope.row)">选中</el-button>
              </template>
            </el-table-column>

          </el-table>
          <el-pagination
              @size-change="handleSizeChangeCustomer"
              @current-change="handleCurrentChangeCustomer"
              :current-page="customerQueryInfo.pageNum"
              :page-sizes="[10, 20, 50, 100, 200]"
              :page-size="customerQueryInfo.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="customerTotal"
          ></el-pagination>
        </div>
      </el-row>
    </el-dialog>




  </div>
</template>

<script>

export default {
  name: 'transact',
  data() {
    return {
      //待办查询条件
      queryInfo:{
        pageNum:1,
        pageSize:10,
      },
      //员工查询条件
      userQueryInfo:{
        pageNum:1,
        pageSize:10,
      },
      //客户查询条件
      customerQueryInfo:{
        pageNum:1,
        pageSize:10,
      },
      //列表数据
      transactList:[],
      //待办分页总条数
      total: 0,
      //员工分页总条数
      userTotal: 0,
      customerTotal: 0,
      //新增弹窗
      ModifyPageVisible:false,
      //选择用户
      userDialog:false,
      customerDialog:false,
      //新增待办对象
      transactInfo:{
        workerName: '',
        workerId: '',
        customerName: '',
        customerId: '',
        number: '',
      },
      //员工集合
      workerList:[],
      //客户集合
      customerList:[],
      //用户角色
      roleList:[],
      //加载
      isLoading: false,
      //新增待办表单验证
      rules:{
        workerName:[
          { required: true, message: '请选择员工', trigger: 'change'},
        ],
        number:[
          { required: true, message: '请填写业务单号', trigger: 'blur' },
        ],
        customerName:[
          { required:true, message: '请选择关联客户', trigger: 'change'},
        ],
        remark:[
          { required: true, message: '请输入待办说明', trigger: 'blur' },
        ]
      }
    }
  },
  created() {
    this.handleGetList();
  },
  methods: {
    //打开选择订单弹窗 查询订单
    handleOpenOrderList(){
      this.orderDialog = true;
      this.handleGetOrderList()
    },
    //搜索待办
    handleSearchList(){
      this.queryInfo.pageNum = 1;
      this.handleGetList();
    },
    //获得待办列表
    handleGetList() {
      this.isLoading = true;
      this.$http.get('transact/getList', {params: this.queryInfo})
          .then(({ data }) => {
            if (data.code === 200) {
              this.transactList = data.data.list;
              this.total = data.data.total;
            }
          })
      this.isLoading = false;
    },
    //提 交
    submitArrivalRemind() {
      this.$refs['transactInfo'].validate((valid) => {
        if (valid) {
          //保存数据
          this.$http.post('transact/add', this.transactInfo)
              .then(({ data }) => {
                console.log(data)
                if (data.code === 200) {
                  this.ModifyPageVisible = false
                  this.handleGetList();
                  this.$message.success('提交成功');
                  this.transactInfo = {};
                  this.$refs['transactInfo'].resetFields();
                }else {
                  this.$message.error(data.message);
                }
              })
        } else {
          return false;
        }
      });
    },
    //待办分页
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.handleGetList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.handleGetList();
    },
    //用户分页
    handleSizeChangeUser(newSize) {
      this.userQueryInfo.pageSize = newSize;
      this.handleGetUserList();
    },
    handleCurrentChangeUser (newPage) {
      this.userQueryInfo.pageNum = newPage;
      this.handleGetUserList();
    },
    //用户分页
    handleSizeChangeCustomer(newSize) {
      this.customerQueryInfo.pageSize = newSize;
      this.handleGetCustomerList();
    },
    handleCurrentChangeCustomer(newPage) {
      this.customerQueryInfo.pageNum = newPage;
      this.handleGetCustomerList();
    },
    //打开选择员工弹窗 查询员工
    handleOpenUserList(){
      this.userDialog = true;
      this.getRoleList();
      this.handleGetUserList();
    },
    //打开选择客户弹窗 查询客户
    handleOpenCustomerList(){
      this.customerDialog = true;
      this.handleGetCustomerList();
    },
    //获得员工列表
    async handleGetUserList() {
      const { data: res } = await this.$http.get("emp/empSystemManage/list", {
        params: this.userQueryInfo,
      });
      this.workerList = res.data.list;
      this.userTotal = res.data.total;
    },
    async handleGetCustomerList () {
      this.isLoading = true
      const { data: res } = await this.$http.get("customer/customerList", {
        params: this.customerQueryInfo,
      });
      this.customerList = res.data.list;
      this.customerTotal = res.data.total;
      this.isLoading = false
    },
    //获取角色列表
    async getRoleList() {
      const { data: res } = await this.$http.get("role/roleList");
      this.roleList = res.data;
    },
    //搜索员工
    handleSearchUserList(){
      this.userQueryInfo.pageNum = 1;
      this.getRoleList();
      this.handleGetUserList();
    },
    //搜索客户
    handleSearchCustomerList(){
      this.customerQueryInfo.pageNum = 1;
      this.handleGetCustomerList();
    },
    //重置员工搜索
    handleQueryInfoUserClear(){
      this.userQueryInfo = {
        userName: "",
        roleId: "",
        pageNum:1,
        pageSize:5,
      }
      this.getRoleList();
      this.handleGetUserList();
    },
    //重置客户搜索
    handleQueryInfoCustomerClear(){
      this.customerQueryInfo = {
        userName: "",
        pageNum:1,
        pageSize:5,
      }
      this.handleGetCustomerList();
    },
    //选中员工之后
    userChoose(param){
      this.userDialog = false;
      this.transactInfo.workerId = param.userId;
      this.transactInfo.workerName  = param.realName;
      this.userQueryInfo = {
        userName: "",
        roleId: "",
        pageNum:1,
        pageSize:5,
      }
      this.$refs.transactInfo.clearValidate('workerName');
    },
    //选中客户之后
    customerChoose(param){
      this.customerDialog = false;
      this.transactInfo.customerId = param.userId;
      this.transactInfo.customerName  = param.realName || param.userName;
      this.customerQueryInfo = {
        userName: "",
        pageNum:1,
        pageSize:10,
      }
      this.$refs.transactInfo.clearValidate('customerName');
    },
    //删除待办
    handleDel(row){
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('transact/delete', row)
            .then(({ data }) => {
              if (data.code === 200) {
                this.handleGetList();
                this.$message.success('删除成功');
              }else {
                this.$message.error(data.message);
              }
            })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //重置待办搜索条件queryInfo
    handleQueryInfoClear(){
      this.queryInfo = {
        pageNum:1,
        pageSize:10,
      }
      this.handleGetList();
    },
    //修改状态
    handleUpdate(row,type){
      this.$confirm('是否确认完成?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let data = {};
        data ={...row};
        if (type == "1"){
          data.officeState = '1';
        }else{
          data.entryState = '1';
        }
        this.$http.post('transact/edit', data)
            .then(({ data }) => {
              if (data.code === 200) {
                this.handleGetList();
                this.$message.success('修改成功');
              }else {
                this.$message.error(data.message);
              }
            })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });








    }
  }
};
</script>

<style lang="less" scoped>
/deep/
/*去除upload组件过渡效果*/
.el-upload-list__item {
  transition: none !important;
}

.bigimg /deep/ ul li {
  width: 100%;
  height: auto;
}

.bigimg /deep/ .el-upload--picture-card {
  display: none;
}

.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.split-col {
  padding-right: 20px;
}

.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.search-btn-container-status {
  text-align: left !important;
}

.mark {
  background: #dbdb86;
  text-align: left;
  margin-bottom: 10px;
}

.el-icon-close {
  cursor: pointer;
}

.dialog-account {
  display: flex;
  flex-wrap: wrap;

  /deep/.el-radio {
    width: 28%;
    margin-bottom: 10px;
  }
}
</style>
